
var url = window.location.origin
var urlDomainName = window.location.hostname
export const BaseUrl =

    url === "http://demoeyrubberplant.cdatinfotech.com" ? "http://demoapieyrubberplant.cdatinfotech.com" :
        url === "http://eyrubberplant.cdatinfotech.com" ? "http://apieyrubberplant.cdatinfotech.com" :
        url === "https://inroad.info" ? "https://api.inroad.info" :
            "http://demoapieyrubberplant.cdatinfotech.com"
            // "http://apieyrubberplant.cdatinfotech.com"



